export default __webpack_public_path__ + "static/media/6785-sev.67b0b0f3.pdf";